import { createSlice } from "@reduxjs/toolkit";

import AlertSliceDto from "dto/redux/alert-slice-dto";

const initialState: AlertSliceDto = {
	error: false,
	message: "",
	code: "",
	action: "",
};

export const alertSlice = createSlice({
	name: "alert",
	initialState,
	reducers: {
		promptAlertMessage: (state, action) => {
			return { ...state, ...action.payload };
		},
		dismissAlertMessage: () => initialState,
	},
});

export const { promptAlertMessage, dismissAlertMessage } = alertSlice.actions;

export default alertSlice.reducer;
